import { render, staticRenderFns } from "./subAgendaMobile.vue?vue&type=template&id=5e514752&scoped=true"
import script from "./subAgendaMobile.vue?vue&type=script&lang=js"
export * from "./subAgendaMobile.vue?vue&type=script&lang=js"
import style0 from "./subAgendaMobile.vue?vue&type=style&index=0&id=5e514752&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e514752",
  null
  
)

export default component.exports